function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M20.7 4h-4.4V2.6c0-.8-.6-1.5-1.5-1.5H9.1c-.8 0-1.5.7-1.5 1.5V4H3.3C1.7 4 .4 5.3.4 6.9V20c0 1.6 1.3 2.9 2.9 2.9h17.4c1.6 0 2.9-1.3 2.9-2.9V6.9c0-1.6-1.3-2.9-2.9-2.9zM9.1 3.3c0-.4.3-.7.7-.7h4.4c.4 0 .7.3.7.7V4H9.1v-.7zM22.2 20c0 .8-.6 1.5-1.5 1.5H3.3c-.8 0-1.5-.7-1.5-1.5v-8h7.4c-.1.2-.1.5-.1.7 0 1.6 1.3 2.9 2.9 2.9s2.9-1.3 2.9-2.9c0-.3 0-.5-.1-.7h7.4v8zm-11.7-7.3c0-.3.1-.5.2-.7h2.5c.1.2.2.5.2.7 0 .8-.7 1.5-1.5 1.5-.7 0-1.4-.7-1.4-1.5zm11.7-2.2H1.8V6.9c0-.8.6-1.5 1.5-1.5h17.4c.8 0 1.5.6 1.5 1.5v3.6z"
});

function SvgAccountIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgAccountIcon;